import type {z} from 'zod';

import {dateWindowRefinement} from './catalogueUi';
import type {trimSchema} from './trimSchema';

export const trimWindow = dateWindowRefinement<z.input<typeof trimSchema>>('validFrom', 'validTo');
